module.exports = __webpack_public_path__ + "static/logo-1cf7a4f596cbd02bfb97d496295d48e6.png";